var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"traffic-light-item"},[_c('div',{staticClass:"value"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"sub"},[_vm._v("\n    "+_vm._s(_vm.secondary)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }